(() => {
  const SELECTOR = '[data-positioned-banner]';

  function initializeBanner(banner) {
    if (!banner || banner.dataset.initialized === 'true') return;

    banner.dataset.initialized = 'true';
    const image = banner.querySelector('.positioned-banner__image');

    if (!image || image.complete) {
      banner.classList.add('is-loaded');
      return;
    }

    image.addEventListener('load', () => banner.classList.add('is-loaded'), {
      once: true
    });
    image.addEventListener('error', () => banner.classList.add('is-loaded'), {
      once: true
    });
  }

  function initializeWithin(root = document) {
    if (root.matches?.(SELECTOR)) initializeBanner(root);
    root.querySelectorAll?.(SELECTOR).forEach(initializeBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeWithin(event.target);
  });
})();
